import AdditionalContent from './AdditionalContent';

export default AdditionalContent;